<template>
  <div style="height: 100vh; display: flex; flex-direction: column;">
    <div
      style="display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; border-bottom: 1px solid #eee; height: 51px;"
    >
      <div
        @click="() => this.onClose && this.onClose()"
        style="font-weight: 600; font-size: 16px; cursor: pointer; display: flex; align-items: center; gap: 5px;"
      >
        <q-icon name="fas fa-chevron-left" class="back__icon" />
        Заменить материалы
      </div>
      <q-btn
        icon="close"
        flat
        round
        dense
        @click="() => this.onClose && this.onClose()"
      />
    </div>
    <div class="change__header">
      <div v-if="projectName">
        <div style="font-size: 14px; color: #666;">Проект:</div>
        <div style="font-weight: 500; font-size: 16px;">{{ projectName }}</div>
      </div>
      <q-btn
        size="md"
        class="recalc-btn"
        @click="recalcSmeta"
        :loading="recalcLoading"
      >
        Перерасчет сметы
        <q-icon name="fa-solid fa-repeat" class="recalc-btn__icon" />
      </q-btn>
    </div>
    <div style="flex: 1; overflow: auto; padding: 16px;">
      <q-linear-progress v-if="this.isFetching" indeterminate />
      <div v-if="this.currentMaterials">
        <p style="margin-bottom: 5px;">Текущие материалы:</p>
        <CustomTable
          v-if="this.currentMaterials"
          title=""
          :rowsData="this.currentMaterials"
          :columns="[{}, {}, {}]"
          :loading="isFetching"
          :hideTopTitle="true"
          :custom-body="true"
          :bottomRow="true"
          :allWidth="true"
          :striped="true"
          :bordered="true"
          :hoverless="true"
          :withoutHead="true"
          :sticky-header="false"
          separator="cell"
        >
          <template #customBody="props">
            <q-tr
              :props="props"
              :style="(this.activeMaterialId === props.row.material_id) ? 'background: rgb(189, 215, 255);' : ''"
            >
              <q-td
                align="left"
                vertical-align="center"
                style="border-left:1px solid rgba(0,0,0,.12);"
              >
                {{ props.row.material_name }}
              </q-td>
              <q-td
                align="center"
                vertical-align="center"
                style="border-left:1px solid rgba(0,0,0,.12); width:150px;"
              >
                <Clickable
                  @click="() => this.onSelectOldMaterial(props.row.material_id)"
                >
                  Заменить
                </Clickable>
              </q-td>
            </q-tr>
          </template>
        </CustomTable>
      </div>
      <div v-else>
        <NotFoundText :paddingSmall="true" :loading="this.isFetching" />
      </div>
    </div>
  </div>

  <!-- Диалог выбора причины изменения сметы -->
  <q-dialog v-model="showReasonDialog" persistent>
    <q-card style="min-width: 500px; max-width: 600px">
      <q-card-section>
        <div class="text-h6">Выберите причину пересчёта сметы</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <q-banner class="bg-blue-1 text-grey-9" style="border-left: 4px solid #1976d2; margin-bottom: 16px;">
          <template v-slot:avatar>
            <q-icon name="info" color="blue" />
          </template>
          <div style="font-size: 14px; line-height: 1.6;">
            <strong>Информация о пересчёте</strong>
            <p style="margin-top: 8px; margin-bottom: 8px;">
              Смета пересчитается <strong>с учётом замененного материала</strong>. 
              При этом <strong>работы останутся</strong>, которые выбраны в проекте. 
              Ничего из пакета тянуться не будет.
            </p>
            <p style="margin-bottom: 0;">
              <strong>Тип пересчета:</strong><br/>
              • <strong>Мягкий пересчет</strong> - пересчитаются только работы, которые еще <strong>не сданы</strong><br/>
              • <strong>Жесткий пересчет</strong> - пересчитаются <strong>все работы</strong>, включая сданные<br/>
              <br/>
              <em style="color: #1976d2;">
                От выбора причины (замена материала, тариф, цена) зависит тип пересчета (мягкий/жесткий), 
                но сам пересчет будет <strong>полным</strong> - пересчитаются все параметры сметы, 
                а не только материалы или цены.
              </em>
            </p>
          </div>
        </q-banner>
        
        <q-select
          v-model="selectedRecalcType"
          :options="recalcTypeOptions"
          option-value="value"
          option-label="label"
          label="Шаг 1: Выберите тип пересчета"
          outlined
          emit-value
          map-options
          @update:model-value="onRecalcTypeChange"
          style="margin-bottom: 16px;"
        />
        
        <q-select
          v-model="selectedReason"
          :options="filteredReasonOptions"
          option-value="reason_code"
          option-label="reason_name"
          label="Шаг 2: Выберите причину изменения"
          outlined
          emit-value
          map-options
          :disable="!selectedRecalcType"
          style="margin-bottom: 16px;"
        />
        
        <q-input
          v-model="recalcComments"
          type="textarea"
          label="Комментарий к пересчету (опционально)"
          outlined
          rows="3"
          hint="Этот комментарий будет сохранен в истории изменений сметы"
        />
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="Отмена" color="primary" @click="cancelRecalc" />
        <q-btn 
          flat 
          label="Пересчитать" 
          color="primary" 
          @click="confirmRecalc"
          :disable="!selectedReason"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import Clickable from '@/components/common/Clickable.vue';
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import NotFoundText from '@/components/common/NotFoundText.vue';
import CustomCheckbox from "@/components/form/CustomCheckbox";
import { MODAL_NAMES } from '@/constants';
import { getProjectMaterials, recalcSmeta, updateWorksetProject, getSmetaChangeReasons, createDS } from './services';
import { useCustomSnackbar } from '@/_helpers/hooks/useCustomSnackbar';
import { useAppStore } from '@/services/store/app'

export default {
  name: "ChangeProjectMaterials",
  props: ['onClose', 'projectId', 'projectData'],
  components: { CustomTable, CustomTableCell, CustomCheckbox, Clickable, NotFoundText },
  data() {
    return {
      activeMaterialId: null,
      materials: null,
      isFetching: false,
      recalcLoading: false,
      showReasonDialog: false,
      selectedRecalcType: null,
      selectedReason: null,
      reasonOptions: [],
      recalcComments: '',
    }
  },
  computed: {
    recalcTypeOptions() {
      return [
        { label: 'Мягкий пересчет (только несданные работы)', value: 'soft' },
        { label: 'Жесткий пересчет (все работы, включая сданные)', value: 'hard' }
      ]
    },
    filteredReasonOptions() {
      if (!this.selectedRecalcType) return []
      return this.reasonOptions.filter(reason => reason.recalc_type === this.selectedRecalcType)
    },
    availableMaterials() {
      return this.materials?.filter(item => item.available)
    },
    currentMaterials() {
      return this.materials?.filter(item => !item.available)
    },
    projectName() {
      if (!this.projectData) return ''
      return (this.projectData.resident_name ?
        `${this.projectData.resident_name} - ${this.projectData.project_type_name}` : '')
    }
  },
  methods: {
    async getMaterials() {
      this.isFetching = true
      const res = await getProjectMaterials(this.projectId)
      this.isFetching = false
      this.materials = res || null
    },
    onSelectOldMaterial(material_id) {
      this.activeMaterialId = material_id || null

      this.showModal(MODAL_NAMES.ChangeProjectMaterials, {
          title: 'Выберите материал',
          projectId: this.projectId,
          materials: this.availableMaterials?.filter(item => item.material_id !== material_id),
          onSubmit: this.onChangeSubmit,
          onClose: () => {
            this.activeMaterialId = null
          }
        });
    },
    async onChangeSubmit(material_set_id, selectedFloors) {
      const ids = Object.keys(selectedFloors || {})
          .filter(floorMapId => !!selectedFloors[floorMapId])
          .map(item => Number(item))

      const res = await this.onSubmit(
        { old_material_id: this.activeMaterialId, new_material_id: material_set_id, entrances: ids, project_id: this.projectId },
      )
      return res
    },
    async onSubmit(body) {
      const res = await updateWorksetProject(body)
      if (!res) return
      this.materials = res
      this.showSucceedSnackbar()
      this.closeModal();
      return res
    },
    async getReasons() {
      const res = await getSmetaChangeReasons()
      if (res) {
        this.reasonOptions = res
      }
    },
    async recalcSmeta() {
      // Показываем диалог выбора причины
      this.showReasonDialog = true
    },
    cancelRecalc() {
      this.showReasonDialog = false
      this.selectedRecalcType = null
      this.selectedReason = null
      this.recalcComments = ''
    },
    onRecalcTypeChange() {
      // Сбрасываем выбранную причину при смене типа
      this.selectedReason = null
    },
    async confirmRecalc() {
      if (!this.selectedReason) return
      
      this.showReasonDialog = false
      this.recalcLoading = true
      const notif = this.$q.notify({
        message: 'Пересчет сметы...',
        color: 'deep-orange',
        spinner: true,
        position: 'top',
        timeout: 100000
      })
      
      const res = await recalcSmeta(this.projectId, this.selectedReason, this.recalcComments || null)
      
      this.recalcLoading = false
      this.selectedRecalcType = null
      this.selectedReason = null
      this.recalcComments = ''
      notif && notif()
      
      if (res) {
        this.showModal(MODAL_NAMES.SmetaRecalcSuccess, {
          title: '',
          message: 'Пересчет сметы выполнен успешно',
          description: 'Необходимо создать доп. соглашение',
          btnText: 'Создать доп. соглашение',
          onSubmit: () => this.handleCreateDS(),
        })
      }
    },
    handleCreateDS() {
      const project_id = this.projectId
      const finish_date = this.projectData?.finish_date

      this.showSecondaryModal(MODAL_NAMES.CONFIRM, {
        title: 'Сменить дату завершения проекта',
        cancelBtnText: 'Оставить и создать ДС',
        btnText: 'Сменить',
        onSubmit: async () => {
          this.showSecondaryModal(MODAL_NAMES.ChangeProjectDate, {
            title: 'Сменить дату завершения проекта',
            body: {
              project_id,
              finish_date,
            },
          })
        },
        onReject: async () => {
          const res = await createDS({ project_finish_date: null, project_id })
          if (res) {
            this.showSucceedSnackbar()
            this.closeModal()
            this.closeSecondaryModal()
          }
        },
      })
    },
  },
  mounted() {
    this.getMaterials()
    this.getReasons()
    document.getElementsByTagName('body')[0].style.overflow = 'hidden'
  },
  unmounted() {
    document.getElementsByTagName('body')[0].style.overflow = ''
  },
  setup() {
    const { showSucceedSnackbar } = useCustomSnackbar();
    const { showModal, closeModal, showSecondaryModal, closeSecondaryModal } = useAppStore()
    return { showSucceedSnackbar, showModal, closeModal, showSecondaryModal, closeSecondaryModal };
  },
};
</script>

<style scoped lang="scss">

.change__header{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  border-bottom: 1px solid #eee;
}
.recalc-btn {
  padding: 7px 10px;
  border-radius: 8px;
  font-weight: 400;
  font-size: 13px !important;
  color: #FFFFFF;
  text-transform: none;
  background-color: #0060FE;

  &:before {
    box-shadow: none !important;
  }

  &__icon {
    margin-left: 7px;
    font-size: 12px !important;
  }
}
</style>
